export type AlertType =
  | "requests_human"
  | "complaint"
  | "urgent"
  | "unsubscribe"
  | "unsubscribe_human"
  | "purchase_urgency"
  | "follow_up";

export const ALERT_LABELS: Record<AlertType, string> = {
  requests_human: "SOLICITA HUMANO",
  complaint: "QUEJA",
  urgent: "URGENTE",
  unsubscribe: "BAJA",
  unsubscribe_human: "BAJA + HUMANO",
  purchase_urgency: "ALTA INTENCIÓN",
  follow_up: "SEGUIMIENTO",
};

export const SENTIMENT_LABELS: Record<string, string> = {
  positive: "Positivo",
  neutral: "Neutral",
  negative: "Negativo",
  ...ALERT_LABELS,
};

export function formatSentimentLabel(value?: string | null): string {
  if (!value) return "—";
  return SENTIMENT_LABELS[value] ?? value.replace(/_/g, " ");
}
